import { PollChipButton, PollTabSectionStack } from "../PollTab.styles";
import { PollSectionTitleTypography } from "../../PostForm.styles";
import { Stack, Typography } from "@mui/material";
import { ReactElement } from "react";

interface ChipButtonsListType {
    items: {
        isSelected: boolean;
        label: string;
        onClick: () => void;
        icon?: ReactElement;
    }[];
    sectionTitle: string;
    allowPollEdit?: boolean;
}

export function ChipButtonsListSection({
    items,
    sectionTitle,
    allowPollEdit = true,
}: ChipButtonsListType) {
    return (
        <PollTabSectionStack>
            <PollSectionTitleTypography>
                {sectionTitle}
            </PollSectionTitleTypography>
            <Stack direction={"row"} gap={"8px"} flexWrap={"wrap"}>
                {items.map(({ isSelected, onClick, label, icon }) => (
                    <PollChipButton
                        onClick={() => {
                            if (!allowPollEdit && !isSelected) {
                                return;
                            }
                            onClick();
                        }}
                        key={label}
                        isActive={isSelected}
                        isDisabled={!allowPollEdit && !isSelected}
                    >
                        {icon}
                        <Typography>{label}</Typography>
                    </PollChipButton>
                ))}
            </Stack>
        </PollTabSectionStack>
    );
}
